export const signatureStyles = [
  {
    value: 'signature-style-1',
    fontFamily: 'Edu AU VIC WA NT Hand, cursive',
  },
  {
    value: 'signature-style-2',
    fontFamily: 'Indie Flower, cursive',
  },
  {
    value: 'signature-style-3',
    fontFamily: 'Grey Qo, cursive',
  },
  {
    value: 'signature-style-4',
    fontFamily: 'Dancing Script, cursive',
  },
  {
    value: 'signature-style-5',
    fontFamily: 'Qwitcher Grypen, cursive',
  },
];

export const signatureStyleImportExpresion = `
          @import url('https://fonts.googleapis.com/css2?family=Dancing+Script&family=Edu+AU+VIC+WA+NT+Hand:wght@400..700&family=Grey+Qo&family=Indie+Flower&family=Qwitcher+Grypen:wght@400;700&display=swap');
          
          .signature-style-1 { font-family: 'Edu AU VIC WA NT Hand', cursive; font-weight: 400; font-style: normal; }
          .signature-style-2 { font-family: 'Indie Flower', cursive; font-weight: 400; font-style: normal; }
          .signature-style-3 { font-family: 'Grey Qo', cursive; font-weight: 400; font-style: normal; }
          .signature-style-4 { font-family: 'Dancing Script', cursive; font-weight: 400; font-style: normal; }
          .signature-style-5 { font-family: 'Qwitcher Grypen', cursive; font-weight: 400; font-style: normal; }
        `;
